function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u66F4\\u591A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu-/-more_horizontal"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "menu-/-more_horizontal-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,13 C5,14.0999999 5.89999998,15 7,15 C8.0999999,15 9,14.0999999 9,13 C9,11.9 8.0999999,11 7,11 C5.89999998,11 5,11.9 5,13 Z M17,13 C17,14.0999999 17.8999996,15 19,15 C20.1000004,15 21,14.0999999 21,13 C21,11.9 20.1000004,11 19,11 C17.8999996,11 17,11.9 17,13 Z M13,11 C14.1000004,11 15,11.9 15,13 C15,14.0999999 14.1000004,15 13,15 C11.9000001,15 11,14.0999999 11,13 C11,11.9 11.9000001,11 13,11 Z",
  fill: "#E89A4F",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,12 C4,13.0999999 4.89999998,14 6,14 C7.0999999,14 8,13.0999999 8,12 C8,10.9 7.0999999,10 6,10 C4.89999998,10 4,10.9 4,12 Z M16,12 C16,13.0999999 16.8999996,14 18,14 C19.1000004,14 20,13.0999999 20,12 C20,10.9 19.1000004,10 18,10 C16.8999996,10 16,10.9 16,12 Z M12,10 C13.1000004,10 14,10.9 14,12 C14,13.0999999 13.1000004,14 12,14 C10.9000001,14 10,13.0999999 10,12 C10,10.9 10.9000001,10 12,10 Z",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
})));

function SvgSidebarMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u66F4\u591A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMore);
export default __webpack_public_path__ + "static/media/sidebar_more.f25bb074.svg";
export { ForwardRef as ReactComponent };